/**
 * "What's in here" — the honest list, shown under the ? button. Only what the code actually
 * does, verified on a device. Update it in the same commit as every feature.
 *
 * Short lines on purpose: this is read on a phone, in a hurry, by someone who has just installed
 * the app. One idea per bullet, no clause stacking. If a line needs a comma and a bracket to
 * survive, it belongs in two lines or in none.
 */
export const MOBILE_NOTES = [
  {
    title: "What it does",
    items: [
      "Pick one or several videos from your phone.",
      "Cut by what's said: the phone listens and makes one clip per sentence.",
      "That listening happens on the phone. Nothing is uploaded, and it works in airplane mode.",
      "Or cut by time — 2, 5 or 10-second clips, instantly, with no listening.",
      "Search the words. Type one and only the moments someone said it are left.",
      "Every clip gets a picture from your own video.",
      "Tap a clip to watch just that piece. Tap the circle to keep it.",
      "The number on the circle is that clip's place in your edit.",
      "The timeline at the bottom is your edit. Slide a clip to move it, tap it to trim it, or bin it.",
      "Play runs the whole edit back to back, even across different videos.",
      "Share makes one video from your edit and hands it to WhatsApp, Instagram or anything else.",
      "Several videos can stay apart, each with its own clock, or join into one long video.",
      "Your last projects are kept. Open them again from Projects.",
    ],
  },
  {
    title: "With a CherryClipz account",
    items: [
      "Send a video to CherryClipz for a far better transcript, who is speaking, and the mood of each line.",
      "It becomes the same video spreadsheet the website makes, in your library.",
      "Open anything already in your library — sent from the website, Premiere or the phone — without uploading it again.",
      "Sign in with the same email code as the website. Your plan's hours apply.",
      "Nothing is ever charged in the app.",
    ],
  },
  {
    title: "How to use it",
    items: [
      "Pick videos, then choose how to cut them.",
      "Tap a clip to watch it. Tap the circle to keep it.",
      "Tap a block in the timeline to trim it. Drag the handles, or use minus and plus.",
      "Press Share when the edit looks right.",
    ],
  },
  {
    title: "Good to know",
    items: [
      "Listening on the phone understands English. It gives no punctuation and no speaker names.",
      "A video with no talking simply keeps its timed clips.",
      "Sending it to CherryClipz is the accurate option.",
      "A video opened from your library can't be shared from the phone yet.",
      "Music, captions and the iPhone version are not built yet.",
    ],
  },
];
